import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  rowBox: {
    marginTop: 24,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default styles;
